module.exports = __webpack_public_path__ + "img/legend-chart-territorial.a2b9a0f6.svg";